import React, { useEffect, useState } from "react";
import { getBirthdays, getBirthdaysAll } from "../Service/Api";
import Slider from "react-slick";
import "../Assets/css/slick.css";
import "../Assets/css/slick-theme.css";
import LazyLoad from "react-lazyload";

const DEFAULT_BIRTHDAY_IMAGE =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/birthday-dummy.png";

const BIRTHDAY_DATA = [
  {
    name: "Student Name",
    class: "Class",
    date: "DD-MM-YYYY",
    attachments: "",
  },
  {
    name: "Student Name",
    class: "Class",
    date: "DD-MM-YYYY",
    attachments: "",
  },
  {
    name: "Student Name",
    class: "Class",
    date: "DD-MM-YYYY",
    attachments: "",
  },
  {
    name: "Student Name",
    class: "Class",
    date: "DD-MM-YYYY",
    attachments: "",
  },
  {
    name: "Student Name",
    class: "Class",
    date: "DD-MM-YYYY",
    attachments: "",
  },
];
const Birthday = () => {
  const [data, setData] = useState([]);
  const [dataAll, setDataAll] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const birthdayData = await getBirthdays();
        setData(birthdayData);
      } catch (error) {
        console.error("Unable to get today's birthdays:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchDataAll = async () => {
      try {
        const birthdayDataAll = await getBirthdaysAll();

        const filterData = birthdayDataAll.filter((item) => {
          const birthdayMonth = new Date(item.date).getMonth();
          const currentMonth = new Date().getMonth();

          return birthdayMonth === currentMonth;
        });

        setDataAll(filterData);
        console.log("Get all birthdays:", filterData);
      } catch (error) {
        console.error("Unable to get monthly birthdays:", error);
      }
    };

    fetchDataAll();
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 4 } },
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 4 } },
      { breakpoint: 567, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } },
    ],
  };

  const settings1 = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1600, settings: { slidesToShow: 2 } },
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 567, settings: { slidesToShow: 2 } },
      { breakpoint: 500, settings: { slidesToShow: 1 } },
    ],
  };

  const getImageSource = (attachments) => {
    return attachments
      ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${attachments}`
      : DEFAULT_BIRTHDAY_IMAGE;
  };

  const handleImageError = (event) => {
    event.currentTarget.onerror = null;
    event.currentTarget.src = DEFAULT_BIRTHDAY_IMAGE;
  };

  const todayBirthdayList = data.length > 0 ? data : BIRTHDAY_DATA;

  const monthlyBirthdayList = dataAll.length > 0 ? dataAll : BIRTHDAY_DATA;

  return (
    <>
      <div className="col-md-6">
        <div className="birthday-block">
          <div className="upcoming">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/candle.gif"
                alt="Birthday candle"
              />
            </LazyLoad>

            <h4>TODAY'S STAR</h4>
          </div>

          <Slider {...settings1}>
            {todayBirthdayList.map((item, index) => (
              <div className="item" key={`${item.name}-${index}`}>
                <div className="birthday-content">
                  <img
                    src={getImageSource(item.attachments)}
                    alt={item.name}
                    onError={handleImageError}
                  />

                  <p>{item.name}</p>
                  <p className="primary">{item.class}</p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <div className="col-md-6">
        <div className="upcoming addColor">
          <h4>
            Birthday In
            <br />
            This Month
          </h4>
        </div>

        <Slider {...settings}>
          {monthlyBirthdayList.map((item, index) => (
            <div className="item" key={`${item.name}-${index}`}>
              <div className="birthday-content">
                <h6>
                  {item.date === "DD-MM-YYYY"
                    ? item.date
                    : new Date(item.date).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                      })}
                </h6>

                <img
                  src={getImageSource(item.attachments)}
                  alt={item.name}
                  onError={handleImageError}
                />

                <p>{item.name}</p>
                <p className="primary">{item.class}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Birthday;
